export default __webpack_public_path__ + "static/media/accredited-charity-seal.170e5318.png";